/* eslint-disable typescript-enum/no-enum */

/**
 * Generic format of API error received from vimeo backend.
 */
export interface IApiError {
  developerMessage: string;
  error: string;
  errorCode: EApiErrorCode;
  file: string;
  internalCode: string;
  line: number;
  logError?: string;
  stack?: unknown;
}

/**
 * Generic error codes from vimeo backend representing PHP counterparts.
 */
export enum EApiErrorCode {
  /**
   * When application was suspended for too long and auth token is invalid.
   * Should block view or manually force token refresh.
   *
   * Happens with any request when:
   *  - Laptop/PC suspended with tab open for too long
   *  - No network for a very long period of time
   *
   *  todo: Handle following error for any request.
   */
  BAD_ARGUMENTS_PROVIDED = 2204,
  NO_PERMISSIONS = 3200,
  AUTHORIZATION_FAILED = 3300,
  GUEST_CODE_AUTHORIZATION_FAILED = 3302,
  ROOM_AUTHORIZATION_FAILED = 3303,
  ROOM_AUTHORIZATION_FAILED_NOT_LIVE_YET = 3304,
  ROOM_AUTHORIZATION_FAILED_SESSION_ENDED = 3305,
  ROOM_AUTHORIZATION_FAILED_AUTH_VALUES_ARE_INVALID = 5026,
  LIVE_STREAM_SIMULTANEOUS_LIMIT = 3423,
  REFERRER_NOT_ALLOWED_TO_EMBED = 3704,
  NOT_FOUND = 5000,
  NO_CREDENTIALS_PROVIDED = 8000,
  NO_USER_CREDENTIALS_PROVIDED = 8003,
  REQUEST_RATE_LIMIT = 9000,
  LIVE_STREAM_NOT_STARTED = 10004,
  LIVE_STREAM_ALREADY_ENDED = 10009,
}

/**
 * Set of internal error codes.
 * Use them to mark category/group of related to error areas.
 */
export enum ELiveErrorCode {
  GENERIC = 1,
  INITIALIZATION = 2,
  DISPOSED = 2,
  RTC = 3,
  MEDIA = 4,
  API_ERROR = 10,
  API_JWT_EXPIRED = 11,
  CORRUPTED_OBJECT = 20,
  INVALID_UPLOAD_SIZE = 41,
  INVALID_PARAMETERS = 50,
  UNAUTHORIZED = 60,
  OPERATION_RESTRICTED = 61,
  TIMEOUT = 100,
  CANCEL = 101,
  UNEXPECTED = 10_000,
}
